"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.config.fine.tuning': '选择训练方法',
    'trainer.config.fine_tuning.lora_extension': 'LoRA 扩展',
    'trainer.config.fine_tuning.fulltrain': '完整训练',
    'trainer.config.train': '开始训练',
};
